export interface IModulesResponse {
    data: {
        modules: IModule[];
    };
}
export interface IPathwayModulesResponse {
    data: {
        pathways: {
            pathwayModules: string[];
        }[];
    };
}

export interface IModuleResponse {
    data: {
        module: IModule;
    };
}
export interface IUnitResponse {
    data: {
        unit: IModuleUnit;
    };
}

export interface IDocument {
    name: string;
    url: string;
    size: number;
    ext: string;
    alt?: string;
}

export interface IImage {
    alt: string;
    url: string;
}
export interface IModule {
    id: string;
    type: "PSYCHOEDUCATIONAL" | "REGULAR";
    title: string;
    description: string;
    tag: string;
    tag_color: string;
    image?: IImage;
    contentAmount?: number;
    documents?: IDocument[];
    units?: IModuleUnit[];
    isFavorite?: boolean;
    moduleProgress?: number;
    unitsProgress?: IUnitProgress[];
}

export interface IUnitItemProgress {
    type: ComponentTypes;
    timestamp: string;
    locale: string;
    completed: boolean;
    strapiItemId: string;
    progress: number;
}

export interface IUnitItem {
    type: ComponentTypes;
    id: string;
    title: string;
    duration: number;
    active?: boolean;
}

export interface IModuleProgress {
    moduleId: string;
    totalUnits: number;
    totalUnitsCompleted: number;
    completed: boolean;
}
export interface IModuleUnitProgress {
    moduleId: string;
    units: IUnitProgress[];
}

export interface IUnitProgress {
    id: string;
    items: IUnitItemProgress[];
    completedItems: number;
}

export interface IModuleUnit {
    id: string;
    title: string;
    description: string;
    tag: string;
    tag_color: string;
    type: ComponentTypes;
    isCompleted?: boolean;
    items: IUnitItem[];
}

export enum ComponentTypes {
    VIDEO = "ComponentItemVideo",
    FORM = "ComponentItemTypeForm",
    RICH_TEXT = "ComponentItemRichText",
    IMAGE = "ComponentItemImage",
    FILE = "ComponentItemFile",
    AUDIO = "ComponentItemAudio",
    INFO_BANNER = "ComponentItemInfoBanner",
    IMAGE_SLIDER = "ComponentItemSliderImage",
    VIDEO_SLIDER = "ComponentItemVideoSlider"
}

export enum ItemTypes {
    AUDIO = "AUDIO",
    FILE = "FILE",
    IMAGE = "IMAGE",
    TEXT = "TEXT",
    FORM = "TYPEFORM",
    VIDEO = "VIDEO"
}

export enum ExternalPlatforms {
    VIMEO = "VIMEO",
    TYPEFORM = "TYPEFORM"
}

export interface IProgress {
    unitId: string;
    itemId: string;
    progress: number;
    itemType: ComponentTypes;
    itemLocale: string;
    externalPlatform?: ExternalPlatforms;
    externalId?: string;
    externalData?: string;
}

export interface IModuleSetProgressPayload extends IProgress {
    moduleId: string;
}
export interface IModulesGetProgressPayload {
    locale: string;
}
export interface IModuleGetProgressPayload {
    moduleId: string;
    locale: string;
}

export interface IUnitItemProgressResponse {
    id: string;
    employeeId: string;
    moduleId: string;
    unitId: string;
    itemId: string;
    itemType: string;
    itemLocale: string;
    externalPlatform: string;
    externalId: string;
    externalData: string;
    progress: number;
    timestamp: Date;
}

export interface IModuleProgressResponse {
    moduleId: string;
    units: IModuleUnit[];
}

export interface IModuleFavoriteResponse {
    strapiModuleId: string;
    favourite: boolean;
}

export interface IPathway {
    0: "PATHWAY_1";
    1: "PATHWAY_1";
    2: "PATHWAY_2";
    3: "PATHWAY_3";
    4: "PATHWAY_4";
    5: "PATHWAY_5";
    6: "PATHWAY_6";
    7: "PATHWAY_7";
    8: "PATHWAY_8";
    9: "PATHWAY_9";
}
